import { render } from "./GrupoSocioNegocioList.vue?vue&type=template&id=63ebe274&scoped=true"
import script from "./GrupoSocioNegocioList.vue?vue&type=script&lang=js"
export * from "./GrupoSocioNegocioList.vue?vue&type=script&lang=js"

import "./GrupoSocioNegocioList.vue?vue&type=style&index=0&id=63ebe274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ebe274"]])

export default __exports__